import Input from '../../../../../../Core/Fields/Floating/Input';
import Date from '../../../../../../Core/Fields/Floating/Date';
import SelectSearch from '../../../../../../Core/Fields/Floating/SelectSearch';
import Checkbox from '../../../../../../Core/Fields/Floating/Checkbox';
import Textarea from '../../../../../../Core/Fields/Floating/Textarea';

const Tab2Box = ({ formData, onFieldChange, extraData }) => {

    return (
        <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
                <div style={{ display: 'flex' }} >
                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Supplier Address</p>
                                </div>
                            </div>
                                    
                            <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <Input label="Select Supplier Address" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input label="Contact Person" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input label="GST Category" style={{ height: "30px" }} value={formData.customer} onChange={(e) => onFieldChange('customer', e.target.value)} />
                                    </div>
                            </div>
                             <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Shipping Addres</p>
                                </div>
                            </div>
                                    
                            <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <Input label="Select Shipping Addres" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input label="Select Dispatch Address" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />
                                    </div>          
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>

                                        <Textarea
            id="ponumber"
            label="Shipping Address"
            value={'' }
            // readOnly={true}

            style={{
              whiteSpace: 'pre-wrap',
            //   border: selectedAddress.Error ? '1px solid red' : ''
            }}
          />

                                    </div>
                                    <div style={{ flex: 1 }}>
                                    </div>          
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 px-2">
                        <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                           <div style={{ display: 'flex', gap: '15px' }}>
                                <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{fontSize:'16px',fontWeight:'600'}}>Company Address</p>
                                    </div>
                                </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                <div style={{ flex: 1 }}>
                                    <SelectSearch
                                        list={extraData.customer_types}
                                        label="Select Billing Address"
                                        style={{ height: "30px" }}
                                        getOptionLabel={(item) => item.name}
                                        getOptionValue={(item) => item.name}
                                        value={formData.company}
                                        onChange={(e) => onFieldChange('customer_type', e.target.value)}

                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                 <Input label="Company GSTIN" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />

                                </div>
                            </div>
                            <div style={{ display: 'flex', gap: '15px' }}>
                          
                                <div style={{ flex: 1 }}>
                                   

                                   <Textarea
                                        id="ponumber"
                                        label="Company Address"
                                        value={'' }
                                        // readOnly={true}

                                        style={{
                                        whiteSpace: 'pre-wrap',
                                        //   border: selectedAddress.Error ? '1px solid red' : ''
                                        }}
                                    />


                                </div>
                                <div style={{ flex: 1 }}>
                                 <Input label="Place of Supply" style={{ height: "30px" }} value={formData.series} onChange={(e) => onFieldChange('series', e.target.value)} />

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
   
        </div>
    );
};

export default Tab2Box;